export default "__VITE_ASSET__Bw9l5icp__"